define.alias("shared/utils/array-filters/get-first-point-by-name", "calendar/utils/array-filters/get-first-point-by-name");